// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1CYBA","bigColWidth":"Table_bigColWidth__3l568","biggerColWidth":"Table_biggerColWidth__BTcW4","row":"Table_row__3G-DF","col":"Table_col__3fMgd"};